import { render } from "./SukuBungaContent.vue?vue&type=template&id=e1ff53f2&scoped=true"
import script from "./SukuBungaContent.vue?vue&type=script&lang=js"
export * from "./SukuBungaContent.vue?vue&type=script&lang=js"

import "./SukuBungaContent.vue?vue&type=style&index=0&id=e1ff53f2&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1ff53f2"]])

export default __exports__